import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("love-cart.service");

const WALLS_ENDPOINT = `/walls`;

export const loveCartService = {
    getRequestEmailHtml(data) {
        logger.trace("getRequestEmailHtml", data);
        return ajaxCall
            .post(`${WALLS_ENDPOINT}/get-request-email-html`, {
                data,
            })
            .catch(handleErrorByMessage());
    },
};
